import './styles/ui-popover.css';
import './ui-bootstrap-custom-tpls-2.5.0.js';
export default 'ui.bootstrap';